import axios from "axios";

// Environment configuration
const getServerConfig = () => {
  const hostname = location.hostname;
  const isLocal = hostname === "localhost" || hostname.endsWith(".test");
  const isStaging = hostname.includes("staging");

  let baseUrl;
  if (isLocal) {
    baseUrl = "http://farmavel.test/api/";
  } else if (isStaging) {
    baseUrl = "https://farmaval-server-v2-staging.on-forge.com/api/";
  } else {
    baseUrl = "https://backend.farmaval.net/v2/api/";
  }

  return {
    base: baseUrl,
    endpoint: "admin_functions.php",
  };
};

const config = getServerConfig();
const server_base = config.base;
const server_url = server_base;

// Get session token from localStorage or URL params
const getSessionToken = () => {
  const page_vars = new URLSearchParams(window.location.search);
  return (
    localStorage.getItem("farmaval_token") ||
    page_vars.get("session_token") ||
    ""
  );
};

// Create axios instance
const axiosInstance = axios.create({
  baseURL: server_base,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false,
});

// Request interceptor to add session token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getSessionToken();
    if (token) {
      // Add token as Authorization header (Bearer token)
      config.headers.Authorization = `Bearer ${token}`;
      // Also add as query parameter for backward compatibility
      config.params = config.params || {};
      config.params.session_token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  },
);

// Repository object with HTTP methods
export const repo = {
  get: (url, params = {}) => {
    return axiosInstance.get(url, { params });
  },

  post: (url, data = {}) => {
    return axiosInstance.post(url, data);
  },

  put: (url, data = {}) => {
    return axiosInstance.put(url, data);
  },

  delete: (url, params = {}) => {
    return axiosInstance.delete(url, { params });
  },
};
